import { getSortComparator } from 'BMapsSrc/util/js_utils';
import { getPropertyTooltip } from './properties_rendering';

export const ClassificationTypes = {
    BINARY: 'Binary',
    REGRESSION: 'Regression',
};

export const Directionality = {
    NOT_APPLICABLE: 'N/A',
    MINIMIZE: 'More negative is better',
    MAXIMIZE: 'More positive is better',
    ONEHUNDRED: 'Closer to 100% is better',
    ZERO: 'Closer to 0% is better',
};

export const ScaleTypes = {
    LINEAR: 'linear',
    LOGARITHMIC: 'logarithmic',
};

export const ValueFormatTypes = {
    DECADE: 'decade',
    TENTHS: 'tenths',
    HUNDREDTHS: 'hundredths',
    THOUSANDTHS: 'thousandths',
    WHOLE_NUMBER: 'wholeNumber',
};

/**
 * Return a sort function based on a property directionality.
 * Importantly, this will sort empty values correctly.
 * Unspecified or N/A directionality will sort empty values low.
 * @param {*} directionality
 * @returns {function}
 */
export function getSortComparatorForDirectionality(directionality) {
    const negativeSorting = [Directionality.MINIMIZE, Directionality.ZERO];
    const emptyValueSortResult = negativeSorting.includes(directionality) ? 1 : -1;
    return getSortComparator(emptyValueSortResult);
}

/**
 * Use for MUI DataGrid `sortingOrder` column property
 * @param {*} directionality
 * @returns {Array<string>}
 */
export function getSortingOrderForDirectionality(directionality) {
    const negativeSorting = [Directionality.MINIMIZE, Directionality.ZERO];
    return negativeSorting.includes(directionality) ? ['asc', 'desc', null] : ['desc', 'asc', null];
}

/**
 * Prepare property group info for ScopedProperty global metadata.
 * @param {{ groupMeta: { label: string, propApplicability },
 * propertyInfo: { [propName: string]: {
 * label, description, unit, directionality, range, goodRange, r2, classificationType
 * }}}}
 * @returns {{ metadata, properties: { metadata: { label, description, tooltip } } }}
 */
export function preparePropertyGroupMetadata({ groupMeta, propertyInfo, tooltipHeading }) {
    return {
        metadata: groupMeta,
        properties: Object.entries(propertyInfo).reduce((acc, [propName, propInfo]) => ({
            ...acc,
            [propName]: {
                metadata: {
                    label: propInfo.label,
                    description: propInfo.description,
                    tooltip: getPropertyTooltip(tooltipHeading, propInfo),
                },
            },
        }), {}),
    };
}
